import React from "react";
import "../designcss/Helpingbusiness.css";

const Helpingbusiness = () => {
  return (
    <div className="business-wrapper">
      <div className="business-container">
        <div className="grows-smarter">
          <h1>Helping Businesses Grow Smarter</h1>
          <h1>with WhatsApp Automation</h1>
        </div>

        <p className="business-api">
          Our WhatsApp marketing platform is built on the official WhatsApp
          Business API, enabling businesses to connect with customers on the app
          they use every day. With smart automation and personalised messaging,
          brands can handle customer support, send important updates, and engage
          potential leads effortlessly.
        </p>

        <div className="vision-mission-container">
          <div className="cardd vision-card">
            <h3>Our Vision</h3>
            <p>
              To enable businesses of any size to create stronger and more
              enduring customer relationships and bring sustainable growth by
              smarter, more personalized WhatsApp business marketing.
            </p>
          </div>

          <div className="cardd mission-card">
            <h3>Our Mission</h3>
            <p>
              To make communication easier to businesses through the best
              WhatsApp marketing software and tools that can make
              individual-customer interaction faster, smarter, and personalized.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Helpingbusiness;
